export default "__VITE_ASSET__D$SbyQtB__"